/* unplugin-vue-components disabled */import { render } from "./inputFile.vue?vue&type=template&id=7384834a&scoped=true"
import script from "./inputFile.vue?vue&type=script&lang=js"
export * from "./inputFile.vue?vue&type=script&lang=js"

import "./inputFile.vue?vue&type=style&index=0&id=7384834a&scoped=true&lang=scss"

import exportComponent from "/nerv.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7384834a"]])

export default __exports__